import React from 'react';

const Technologies = () => {
  const techCategories = [
    {
      category: 'Frontend',
      technologies: [
        'React', 'Next.js', 'Vue.js', 'Angular', 'TypeScript', 'Tailwind CSS', 'Redux', 'GraphQL'
      ]
    },
    {
      category: 'Backend',
      technologies: [
        'Node.js', 'Python', 'Java', 'Go', 'Ruby', '.NET', 'PHP', 'Rust'
      ]
    },
    {
      category: 'Mobile',
      technologies: [
        'React Native', 'Flutter', 'Swift', 'Kotlin', 'Xamarin', 'Ionic', 'PWA', 'Capacitor'
      ]
    },
    {
      category: 'Database',
      technologies: [
        'PostgreSQL', 'MongoDB', 'MySQL', 'Redis', 'Elasticsearch', 'DynamoDB', 'Firebase', 'Oracle'
      ]
    },
    {
      category: 'Cloud & DevOps',
      technologies: [
        'AWS', 'Google Cloud', 'Azure', 'Docker', 'Kubernetes', 'Jenkins', 'GitLab CI', 'Terraform'
      ]
    },
    {
      category: 'AI & ML',
      technologies: [
        'TensorFlow', 'PyTorch', 'OpenAI', 'Scikit-learn', 'Keras', 'Computer Vision', 'NLP', 'LangChain'
      ]
    }
  ];

  return (
    <section className="py-20">
      <div className="max-w-7xl mx-auto content-padding">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Technology <span className="brand-gradient">Stack</span>
          </h2>
          <p className="text-lg text-dark-muted max-w-2xl mx-auto">
            We leverage cutting-edge technologies to build robust, scalable, and future-proof applications.
          </p>
        </div>

        {/* Tech Categories */}
        <div className="space-y-8">
          {techCategories.map((category, index) => (
            <div key={index} className="bg-dark-surface rounded-xl p-6 border border-dark-border">
              <h3 className="text-xl font-semibold mb-4 text-brand">
                {category.category}
              </h3>
              <div className="flex flex-wrap gap-3">
                {category.technologies.map((tech, techIndex) => (
                  <span
                    key={techIndex}
                    className="px-4 py-2 bg-dark-bg border border-dark-border rounded-lg text-sm hover:border-brand/50 hover:bg-brand/5 transition-all duration-300 cursor-default"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Message */}
        <div className="mt-12 text-center bg-gradient-to-r from-brand/10 via-brand-light/10 to-highlight/10 rounded-xl p-8">
          <h3 className="text-2xl font-semibold mb-3">
            Not seeing your preferred technology?
          </h3>
          <p className="text-dark-muted mb-6 max-w-2xl mx-auto">
            Our versatile team can adapt to your existing tech stack or recommend the best technologies for your specific needs.
          </p>
          <button 
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="outline-btn"
          >
            Discuss Your Tech Stack
          </button>
        </div>
      </div>
    </section>
  );
};

export default Technologies;

